import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ApiService } from './api.service';

export const propertyContextGuard: CanActivateFn = async () => {
  const api = inject(ApiService);
  const router = inject(Router);
  try {
    const ctx = await firstValueFrom(
      api.get<{ activeProperty: { id: number; code: string; name: string; vmApiBaseUrl: string } | null }>('/context/property'),
    );
    if (ctx.activeProperty?.id) return true;
  } catch {
    // no-op
  }
  await router.navigateByUrl('/properties');
  return false;
};
